/// «Вхід за обличчям» — the enrolment check on the client card and the
/// entrance kiosk (specs/access.md §6). In its own file so it merges cleanly
/// next to other sections (uk.ts carries one line for it). Sentence case.
/// The kiosk speaks to the client at the door, not to the desk: «ви», short,
/// readable from two metres.

export const faceUk = {
  enrol: {
    loadingModels: 'Готуємо розпізнавання…',
    checking: 'Перевіряємо знімок…',
    ready: 'Шаблон готовий',
    readyHint: 'Одне живе обличчя, видно чітко — можна зберігати.',
    no_face: 'На знімку не видно обличчя. Нехай клієнт подивиться прямо в камеру.',
    several_faces: 'У кадрі кілька облич. Залиште в кадрі лише клієнта.',
    too_small: 'Обличчя замале. Нехай клієнт підійде ближче до камери.',
    not_live: 'Не схоже на живе обличчя — можливо, це фото чи екран. Зніміть клієнта ще раз.',
    photoOnly:
      'Розпізнавання не завантажилось, тож збережемо лише фото. Камера біля дверей не впізнає клієнта, доки фото не переснять.',
    failed: 'Не вдалося перевірити знімок. Спробуйте ще раз.',
  },

  kiosk: {
    title: 'Кіоск входу',
    pairTitle: 'Підключити камеру біля дверей',
    pairSubtitle:
      'Цей пристрій стане кіоском входу за обличчям. ID і ключ пристрою панель показує один раз — коли реєструєте пристрій виду «Камера».',
    orgId: 'ID компанії',
    deviceId: 'ID пристрою',
    key: 'Ключ пристрою',
    idError: 'Це не схоже на ID: 36 символів із дефісами.',
    keyError: 'Ключ — рядок із 32 символів, як його показала панель.',
    pair: 'Підключити',
    privacy: 'Кадри з камери не залишають цей пристрій: на сервер іде лише шаблон обличчя — 128 чисел.',

    lookHere: 'Подивіться в камеру',
    holdStill: 'Тримайте обличчя рівно',
    comeCloser: 'Підійдіть ближче',
    checking: 'Перевіряємо…',
    starting: 'Вмикаємо камеру…',

    welcome: (name: string) => `Ласкаво просимо, ${name}`,
    welcomeNoName: 'Ласкаво просимо!',
    welcomeHint: 'Вхід відмічено. Гарного тренування!',
    refused: 'Вхід не відкрито',
    toDesk: 'Підійдіть, будь ласка, до рецепції.',
    reasons: {
      face_not_recognised: 'Не впізнали обличчя',
      face_ambiguous: 'Не вдалося точно впізнати',
      face_not_enrolled: 'Обличчя не зареєстроване',
      face_not_live: 'Не схоже на живе обличчя',
      already_inside: 'Ви вже в залі',
    } as Readonly<Record<string, string>>,
    /// Where the server's sentence is written for the desk, the client at the
    /// door gets this instead.
    hints: {
      face_not_live: 'Подивіться прямо в камеру — без фото й екранів.',
      already_inside: 'Вхід уже відмічено. Якщо ви виходили — підійдіть до рецепції.',
      unknown_person: 'Підійдіть, будь ласка, до рецепції.',
    } as Readonly<Record<string, string>>,
    offline: 'Немає звʼязку із сервером',
    offlineHint: 'Спробуйте ще раз за хвилину або підійдіть до рецепції.',

    camera: (label: string) => `Камера: ${label}`,
    cameraDenied: 'Немає доступу до камери — дозвольте його в налаштуваннях браузера',
    cameraMissing: 'Камеру не знайдено',
    modelsLoading: 'Моделі завантажуються',
    modelsReady: 'Моделі готові',
    modelsFailed: 'Моделі не завантажились — оновіть сторінку',
    lastCheck: (time: string) => `Остання перевірка о ${time}`,
    noChecks: 'Перевірок ще не було',

    settings: 'Налаштування кіоску',
    settingsHint: 'Будь-яка камера, яку бачить браузер: вбудована, USB чи камера планшета.',
    cameraPick: 'Камера',
    fullscreen: 'На весь екран',
    device: (id: string) => `Пристрій ${id.slice(0, 8)}…`,
    unpair: 'Відключити кіоск',
    unpairTitle: 'Відключити цей кіоск?',
    unpairMessage: 'ID і ключ пристрою зітруться з цього браузера. Щоб підключити його знову, знадобляться ID і ключ із панелі.',
    wrongKey: 'Пристрій не знайдено або ключ не підходить',
    wrongKeyHint: 'Можливо, пристрій вимкнули чи змінили йому ключ у панелі. Підключіть кіоск заново.',
    repair: 'Підключити заново',
    server: 'Сервер не відповів як слід. Спробуйте ще раз за хвилину.',
    offlinePair: 'Немає звʼязку із сервером. Перевірте інтернет і спробуйте ще раз.',
  },
}
